import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { ACADEMY_WEB_URL } from '@/lib/academyLinks'

/**
 * Старый адрес публичной страницы курса (`/course/:id`). Своей страницы курса у
 * студии больше нет (решение заказчика, 12.10): ученик смотрит курс в веб-академии,
 * туда и уводим — уже разосланные ссылки не должны вести в пустоту.
 */
const AcademyCourseRedirect = () => {
  const id = Number(useParams<{ courseId: string }>().courseId)
  const valid = Number.isInteger(id) && id > 0
  useEffect(() => {
    if (valid) window.location.replace(`${ACADEMY_WEB_URL}/library/${id}`)
  }, [id, valid])
  return valid ? null : <Navigate to="/dashboard" replace />
}

export default AcademyCourseRedirect
